import {AnyAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type ChatProps = {
  historyList: any
  historyMore: boolean
  historyOffset: number
  chatInfo: any
  characterInfo: any[]
  userInfo: any
  audioInfo: any
}

const initialState = {
  historyList: [],
  historyMore: false,
  historyOffset: 0,
  characterInfo: [],
  chatInfo: {},
  userInfo: {},
  audioInfo: {},
} as ChatProps

// const root = 'http://mock.ixiaochuan.cn/mock/412'
export const openChat = createAsyncThunk<any, any>(
  'openChat',
  async (arg, store) => {
    return req(
      '/xai_open_conversation',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const sendChat = createAsyncThunk<any, any>(
  'sendChat',
  async (arg, store) => {
    return req(
      '/xai_chat',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getChatHistory = createAsyncThunk<any, any>(
  'getChatHistory',
  async (arg, store) => {
    return req(
      '/xai_get_chat_history',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getHistory = createAsyncThunk<any, any>(
  'getHistory',
  async (arg, store) => {
    return req(
      '/xai_get_chat_history',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getChatInfo = createAsyncThunk<any, any>(
  'getChatInfo',
  async (arg, store) => {
    return req(
      '/xai_get_chat_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getPredictiveInput = createAsyncThunk<any, any>(
  'getPredictiveInput',
  async (arg, store) => {
    return req(
      '/xai_predictive_input',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getTTS = createAsyncThunk<any, any>(
  'getTTS',
  async (arg, store) => {
    return req(
      '/xai_character_tts',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getExample = createAsyncThunk<any, any>(
  'getExample',
  async (arg, store) => {
    return req(
      '/xai_predictive_input',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const addMsg = createAsyncThunk<any, any>(
  'addMsg',
  async (arg, store) => {
    return arg
  }
)

export const updateMsg = createAsyncThunk<any, any>(
  'updateMsg',
  async (arg, store) => {
    return arg
  }
)

export const continueMsgCallback = createAsyncThunk<any, any>(
  'continueMsgCallback',
  async (arg, store) => {
    return req(
      '/xai_continue_conversation',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getRoleStatus = createAsyncThunk<any, any>(
  'getRoleStatus',
  async (arg, store) => {
    return req(
      '/xai_get_role_mode',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const setChatBackground = createAsyncThunk<any, any>(
  'setChatBackground',
  async (arg, store) => {
    return req(
      '/xai_set_bg_img',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getNewReply = createAsyncThunk<any, any>(
  'getNewReply',
  async (arg, store) => {
    return req(
      '/xai_chat_repeat',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getLoadingReply = createAsyncThunk<any, any>(
  'getLoadingReply',
  async (arg, store) => {
    return req(
      '/xai_get_loading_chat',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    decreaseMsg(state, action) {
      return {
        ...state,
        historyList: action.payload,
      }
    },
    clearHistoryList(state) {
      return {
        ...state,
        historyList: [],
        historyMore: false,
      }
    },
    addHistorys(state, action) {
      return {
        ...state,
        historyList: state.historyList.concat(action.payload),
      }
    },
    toggleBgMusic(state) {
      return {
        ...state,
        chatInfo: {
          ...state.chatInfo,
          isPlay: !state.chatInfo.isPlay,
        },
      }
    },
    toggleVoice(state) {
      return {
        ...state,
        chatInfo: {
          ...state.chatInfo,
          voiceIsPlay: !state.chatInfo.voiceIsPlay,
        },
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(openChat.fulfilled, (state, action) => {
      return {
        ...state,
        historyList: action.payload.messages,
        memoryInfo: action.payload.memoryInfo,
      }
    })
    builder.addCase(getChatHistory.fulfilled, (state, action) => {
      return {
        ...state,
        historyList: action.payload.messages?.concat(state.historyList),
        historyMore: action.payload.more,
        historyOffset: action.payload.offset,
      }
    })
    builder.addCase(getChatInfo.fulfilled, (state, action) => {
      return {
        ...state,
        chatInfo: action.payload?.chatInfo,
        userInfo: action.payload?.userInfo,
        characterInfo: action.payload?.characterInfo,
        momentInfo: action.payload?.momentInfo,
      }
    })
    builder.addCase(getTTS.fulfilled, (state, action) => {
      return {
        ...state,
        audioInfo: action.payload,
      }
    })
    builder.addCase(addMsg.fulfilled, (state, action) => {
      return {
        ...state,
        // historyList: [...state.historyList, action?.payload],
        historyList: state.historyList.concat(action?.payload),
      }
    })
    builder.addCase(updateMsg.fulfilled, (state, action) => {
      return {
        ...state,
        historyList: action?.payload,
      }
    })
    builder.addCase(sendChat.fulfilled, (state, action) => {
      return {
        ...state,
        characterInfo: action.payload?.characters || state.characterInfo,
      }
    })
    builder.addCase(getNewReply.fulfilled, (state, action) => {
      return {
        ...state,
        characterInfo: action.payload.characters || state.characterInfo,
      }
    })
  },
})

export default chatSlice.reducer
